import { resetarParaEstadoInicial } from '@/utils/executoras/executoras'
import {
  vuexMapDefaultsMutations,
  vuexMapDefaultsGetters
} from '@/utils.store'

function defaultState () {
  return {
    id: null,
    nomeDaVerba: {
      selected: null,
      loaded: []
    },
    categoriasDeQuemSeAplica: {
      selected: {id: 'customRules', name: 'regras de cálculo'},
      loaded: [
        {id: 'all', name: 'todos'},
        {id: 'customRules', name: 'regras de cálculo'},
        {id: 'employers', name: 'empregadores'},
        {id: 'companies', name: 'locais de trabalho'},
        {id: 'routines', name: 'escalas'},
        {id: 'whbRules', name: 'regras de banco de horas'}
      ]
    },
    itensDeQuemSeAplica: { selected: null, loaded: [] },
    
    
    categoriasDeExcecoes: {
      selected: {id: 'employers', name: 'empregadores'},
      loaded: [
        {id: 'customRules', name: 'regras de cálculo'},
        {id: 'employers', name: 'empregadores'},
        {id: 'companies', name: 'locais de trabalho'},
        {id: 'routines', name: 'escalas'},
        {id: 'whbRules', name: 'regras de banco de horas'}
      ]
    },
    itensDeExcecoes: { selected: null, loaded: [] },
    possuiExcecoes: false,
    
    codigo: '',
    verbasSincronizadas: [],
    quantidadeDeVerbasSincronizadas: 0,
    verbasCriadasOuEditadas: [],
    templates: {
      selected: null,
      loaded: []
    },
    regrasDeCalculo: [],
    regrasDeBanco: [],
    empregadores: [],
    escalasDeTrabalho: [],
    locaisDeTrabalho: [],
    parametrizador: null,
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetarParaEstadoInicial(state, defaultState())
  },
  limparVerbasCriadasOuEditadas (state) {
    state.verbasCriadasOuEditadas = []
  },
  
  
  setPossuiExcecoes (state, valor) {
    state.possuiExcecoes = valor
  },
  
  
  limparItensDeExcecoes (state) {
    state.itensDeExcecoes = { selected: null, loaded: [] }
  }
}

const actions = {
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}